import {
  Box,
  Button,
  CardActions,
  CardContent,
  CardHeader,
  Drawer
} from "../../../components";
import { notification, SessionService } from "../../../services";

const FiltroAvancadoDialog = ({
  children,
  filtrosAvancados,
  setFiltrosAvancados,
  filtrosAplicadosImpressao,
  setFiltrosAplicadosImpressao,
  setOpenFiltroAvancadoDialog,
  openFiltroAvancadoDialog,
  propriedadeRelatorio,
  setAbrirDialogoVisualizarRelatorio,
  configuracoes,
  validationError,
}) => {
  const sessionService = new SessionService();

  const validateFiltros = () => {
    if (validationError.length > 0) {
      notification.alertaGenericos(
        `${validationError[0]} inválido(a)`
      );
      return false;
    }

    return true;
  }

  const onClickVisualizarRelatorio = async () => {
    let filtros = { ...filtrosAvancados, ...filtrosAplicadosImpressao };
    const validacao = validateFiltros();
    if (!validacao) return;

    const data = await propriedadeRelatorio.funcaoBuscarDadosRelatorio({
      subgrupo: propriedadeRelatorio.subgrupo,
      tituloRelatorio: propriedadeRelatorio.name,
      tipoRelatorio: propriedadeRelatorio.tipo,
      empresa: sessionService.getEmpresaRelatorio(),
      filtros,
      configuracoes,
    });
    if (!verificaDados(data) || !verificaDados(data.data)) {
      return notification.alertaGenericos(
        "Dados não encontrados para o período selecionado."
      );
    }
    setAbrirDialogoVisualizarRelatorio(true);
  };

  function onCloseVisualizarRelatorio() {
    setFiltrosAvancados({});
    setFiltrosAplicadosImpressao({});
    setOpenFiltroAvancadoDialog(false);
  }

  function verificaDados(dados) {
    if (dados == null || dados == undefined) {
      return false;
    }
    const temValores = Object.values(dados).some((valor) => {
      if (typeof valor === "object") {
        return verificaDados(valor);
      } else if (Array.isArray(valor) && valor?.length) {
        return true;
      } else {
        return valor != null && valor != undefined;
      }
    });
    return temValores;
  }

  return (
      <Drawer
        id='container-filtro'
        anchor="right" 
        open={openFiltroAvancadoDialog} 
        onClose={onCloseVisualizarRelatorio}
        variant="temporary"
        SlideProps={{ timeout: 600 }}
        keepMounted 
        sx={{ 
          zIndex: 1500, 
          '& .MuiDrawer-paper': { 
            width: 550, 
          }, 
          '& .MuiSlide-enter, & .MuiSlide-exit': { 
            transitionTimingFunction: 'cubic-bezier(0.25, 0.8, 0.25, 1)', 
            transitionDuration: '700ms', 
          }, 
          '& .MuiSlide-entered': { 
            transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)', 
            transitionDuration: '700ms', 
          }, 
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%", 
          }}
        >
          <CardHeader
            id="cabecalhoFiltroRelatorio"
            title={`Filtro - ${propriedadeRelatorio?.name?.split("-")[1]}`}
            sx={{ margin: "8px 0px -16px 0px !important", }}
          />
          <CardContent>{children}</CardContent>
          <CardActions sx={{ justifyContent: "space-between", margin: "1px !important", mt: "auto !important" }}>
            <Button
              variant="contained"
              color="padrao"
              onClick={() => onCloseVisualizarRelatorio()}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Sair
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onClickVisualizarRelatorio()}
            >
              Visualizar Relatório
            </Button>
          </CardActions>
        </Box>
      </Drawer>
  );
};

export default FiltroAvancadoDialog;
